<h1 mat-dialog-title>{{ data.title ? data.title : "ERROR" }}</h1>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (data.statusText) {
  <p>{{ "Status: " + data.statusText }}</p>
  } @if (data.origin === 'jalon') {
  <div class="container">
    <div class="center">
      <button
        mat-stroked-button
        color="primary"
        class="logs"
        (click)="openLogs(data.NoLanctBatch)"
      >
        <mat-icon>summarize</mat-icon>{{ "    Voir les logs" }}
      </button>
    </div>
  </div>
  } @if (data.origin === 'jalon') {
  <p>
    {{ "Numéro de lancement: " + data.NoLanctBatch }}
  </p>
  } @if (data.errors !== undefined) {
  <ul>
    @for (error of data.errors; track error) {
    <li>
      <span>&#10003;</span>
      {{ error }}
    </li>
    }
  </ul>
  } @if (data.error?.errors) {
  <p>
    {{ data.error?.errors | json }}
  </p>
  } @if (errorMsg) {
  <p>{{ errorMsg }}</p>
  } @if (data.message) {
  <p>{{ data.message }}</p>
  } @if (data.fullError) {
  <p>{{ data.fullError }}</p>
  }
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    Ok
  </button>
</div>
